import { render, staticRenderFns } from "./cloud-event-detail.vue?vue&type=template&id=8b775a22&scoped=true&"
import script from "./cloud-event-detail.vue?vue&type=script&lang=js&"
export * from "./cloud-event-detail.vue?vue&type=script&lang=js&"
import style0 from "./cloud-event-detail.vue?vue&type=style&index=0&id=8b775a22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b775a22",
  null
  
)

export default component.exports